module.exports = __webpack_public_path__ + "img/91807.f7e9d2ef.svg";